var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { PureComponent } from 'react';
import { defaultProps } from './defaults';
import { InputTag, LabelTag, DivTag } from '../../Utils/AtomicTag';
import { omit } from '../../Utils/object';
var Checkbox = /** @class */ (function (_super) {
    __extends(Checkbox, _super);
    function Checkbox(props) {
        var _this = _super.call(this, props) || this;
        //方法
        _this.handleChange = function (e) {
            _this.setState({
                checked: !_this.state.checked,
                triggerCheck: !_this.state.checked,
                indeterminateStatus: false,
            });
            _this.props.onChange && _this.props.onChange(e);
        };
        _this.handleLabel = function (e) {
            if (e.target.className.includes('input-box')) {
                e.stopPropagation();
            }
        };
        var checked = 'checked' in props ? props.checked : props.defaultChecked;
        _this.state = {
            checked: checked,
            preCheckedStatus: props.checked,
            triggerCheck: false,
            indeterminateStatus: props.indeterminate,
            preIndeterminate: null,
        };
        return _this;
    }
    Checkbox.getDerivedStateFromProps = function (nextProps, prevState) {
        var status = null;
        if (nextProps.indeterminate !== prevState.preIndeterminate) {
            status = Object.assign({}, {
                indeterminateStatus: nextProps.indeterminate,
                preIndeterminate: nextProps.indeterminate,
            });
        }
        if ('checked' in nextProps && nextProps.checked !== prevState.checked) {
            status = Object.assign({}, status, {
                checked: nextProps.checked,
                triggerCheck: nextProps.checked,
            });
        }
        return status;
    };
    Checkbox.prototype.render = function () {
        var _this = this;
        var _a = this.props, contentType = _a.contentType, disabled = _a.disabled, value = _a.value, children = _a.children, className = _a.className, style = _a.style;
        //样式
        var LabelWrapperLeft = contentType == 'inputStyle' ? ['pl-px-24'] : [];
        var LabelWrapperBox = LabelWrapperLeft.concat([
            'relative',
            'inline-block',
            'mr-px-10',
        ]);
        var CheckInputBox = ['hidden'];
        var SpanWord = ['cursor-pointer', 'pr-px-10', 'inline-block'];
        var otherProps = omit(this.props, [
            'indeterminate',
            'defaultChecked',
            'checked',
            'contentType',
            'children',
            'style',
            'className',
            'onChange',
        ]);
        return (React.createElement(LabelTag, { name: Checkbox.NAME, className: className, atomics: LabelWrapperBox, onClick: function (e) {
                _this.handleLabel(e);
            }, style: __assign({}, style) },
            React.createElement(InputTag, __assign({ type: "checkbox", atomics: CheckInputBox }, otherProps, { checked: this.state.checked, value: children ? children.toString() : '', disabled: disabled, onChange: function (e) {
                    _this.handleChange(e);
                }, autoPrefixedClassName: contentType == 'fontStyle'
                    ? 'font-box'
                    : contentType == 'contentStyle'
                        ? 'content-box'
                        : 'input-box' })),
            React.createElement(DivTag, { autoPrefixedClassName: "input-parent", className: this.state.triggerCheck ? 'trigger-parent' : '' },
                React.createElement(DivTag, { atomics: SpanWord, autoPrefixedClassName: "checkbox-word", className: this.state.indeterminateStatus ? 'checkbox-word-indeterminate' : '' }, children))));
    };
    Checkbox.defaultProps = defaultProps;
    Checkbox.NAME = 'checkbox';
    Checkbox.displayName = 'Checkbox';
    return Checkbox;
}(PureComponent));
export { Checkbox };
